import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/city-background.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "contact-image",
  class: "image-background-login"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ForgotPasswordSendEmail = _resolveComponent("ForgotPasswordSendEmail")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_ForgotPasswordSendEmail)
  ], 64))
}